

























import { Component, Vue } from 'vue-property-decorator';
import ProjectNew from '@/components/Project/ProjectNew.vue';

@Component({
  components: {
    ProjectNew,
  },
})
export default class ProjectNewButton extends Vue {
  public showDialog = false;
}
